<template>
    <div class="uc-main-box">
        <digitalHeader @changeTab="changeTab" v-if="headerFlag"/>
        <bkHeader v-else/>
        <div class="ifeames">
            <iframe id="ifra" width="100%" :height="iframeHeight" scrolling="no" 
                :src="'https://dhc.library.sh.cn/uc/relation.html?uri='+relationUri+'&token='+getTokenFunc()"></iframe>
        </div>
    </div>
</template>

<script>
import digitalHeader from '../../components/resultNav/digitalHeader';
import bkHeader from '../../views/bk/nav2/bkHeader';
export default {
    components:{
        digitalHeader,
        bkHeader
    },
    data(){
        return {
            headerFlag: true,
            tabIndex: 0,
             iframeHeight: 600,
            relationUri: 'http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc',
            relationFrom: '&from=bk',
        }
    },
    created(){
        this.getRelationFrom();
    },
    mounted(){
        this.$nextTick(()=>{
            this.onReinitIframe();
        })
    },
    methods:{
        changeTab(index){
            this.tabIndex = index;
        },
        getRelationFrom(){ // 获取来源 大数据平台 或 报刊库
            let _RELATION_URI = this.getZhUrlParam('uri');
            if(this.isEmpty(_RELATION_URI)) _RELATION_URI = localStorage.RELATION_URI;
            this.relationUri = _RELATION_URI;

            let _from = this.getZhUrlParam('from');
            if(this.isEmpty(_from)) {
                _from = localStorage.RELATION_FROM;
                if(this.isEmpty(_from)) return;
            }
            this.relationUri = this.relationUri + '&from=' + _from;
            this.headerFlag = false;
        },
        onReinitIframe(){ // iframe高度自适应
            let _this = this;
            let iframe = document.getElementById("ifra");
            window.setInterval(function () {
                let iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
                if (iframeWin.document.documentElement || iframeWin.document.body) {
                    iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
                }
            }, 200);
            window.onresize = ()=>{
            }
        },
        iframeEndLoading(){ // iframe加载结束
            var _this = this
            const iframe = document.querySelector('#ifra');
            // 处理兼容行问题
            if (iframe.attachEvent) {
                iframe.attachEvent('onload', function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                })
            } 
            else {
                iframe.onload = function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                }
            }
        },
    }
}
</script>

<style lang="less" scoped>
.uc-main-box{
    background: #e3e3e3;
    width: 100%;
    min-height: calc(100vh);
    .filters{
        display: none!important;
    }
    .ifeames{
        iframe{
            border: none;
            min-height: 600px;
            overflow: hidden;
        }
    }
}
</style>